import gql from 'graphql-tag'
import {
	media as mediaFragment
} from './fragments'

export default gql`
query getMedia($id: ID!) {
	cashAssist {
		getMedia(id: $id) {
			id
			mod_ver
			...mediamain
			cashRegisterId
		}
	}
}
${mediaFragment}`

